import { render, staticRenderFns } from "./Keyanys.vue?vue&type=template&id=0f2d0ed2&scoped=true"
import script from "./Keyanys.vue?vue&type=script&lang=js"
export * from "./Keyanys.vue?vue&type=script&lang=js"
import style0 from "./Keyanys.vue?vue&type=style&index=0&id=0f2d0ed2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d0ed2",
  null
  
)

export default component.exports